module.exports = __webpack_public_path__ + "static/edit-568ef4c9d7a5d200789d66d6dd22f20b.png";